import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MachineRequestType } from "@enums/machineRequestType.enum";
import { ProductionStatus } from "@enums/productionStatus.enum";
import { environment } from "@environments/environment";
import { GetProductionStatusColor } from "@helpers/getProductionStatusColor";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { CloseSupervisorRequest } from "@interfaces/closeSupervisorRequest.interface";
import { InterfaceDevice } from "@interfaces/interfaceDevice.interface";
import { FirewallLog } from "@interfaces/models/firewallLog.interface";
import { FirewallLogFailureReason } from "@interfaces/models/firewallLogFailureReason.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { Part } from "@interfaces/models/part.interface";
import { SupervisorRequestReason } from "@interfaces/models/supervisorRequestReason.interface";
import { WorkOrderStage } from "@interfaces/models/workOrderStage.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { AuthService } from "@services/auth.service";
import { FirewallLogService } from "@services/firewallLog.service";
import { FirewallLogFailureReasonService } from "@services/firewallLogFailureReason.service";
import { InterfaceDeviceService } from "@services/interfaceDevice.service";
import { MachineService } from "@services/machine.service";
import { SupervisorRequestReasonService } from "@services/supervisorRequestReason.service";
import { WorkOrderStageService } from "@services/workOrderStage.service";
import { ToastService } from "angular-toastify";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "operator",
	styleUrls: ["operator.css"],
	templateUrl: "operator.html"
})
export class OperatorComponent {
	areasOfIssue: any[] = [];
	availableStages: WorkOrderStage[] = [];
	clientName = "";
	closeSupervisorRequestDto: CloseSupervisorRequest = new CloseSupervisorRequest();
	companyName = "";
	copyright = "";
	currentStatus = ProductionStatus.Idle;
	currentStatusColor = "";
	interfaceDevice: InterfaceDevice = new InterfaceDevice();
	interfaceDeviceId = 0;
	isLoading = false;
	machine = new Machine();
	machineId = 0;
	machineRequestTypes: any;
	nokReasons: FirewallLogFailureReason[] = [];
	openSupervisorRequestId?: number;
	operatorName = "";
	part = new Part();
	partImage = "";
	processName = "";
	profileId = 0;
	quantityComplete = 0;
	quantityEntered = 0;
	quantityNok = 0;
	quantityRequired = 0;
	runningStages: WorkOrderStage[] = [];
	selectedArea = "";
	selectedMachineRequestType = MachineRequestType.Stillage;
	selectedPaint = false;
	selectedProduction = false;
	selectedReason?: number;
	selectedSupervisorRequestReasonId = 1;
	showCloseSupervisorRequestForm = false;
	showCloseSupervisorRequestFormLogin = false;
	showComplete = false;
	showFirewall = false;
	showMode = false;
	showNok = false;
	showOpenMachineRequestForm = false;
	showOpenSupervisorRequestForm = false;
	showPopup = false;
	showSuperLogin = false;
	showSupervisor = false;
	stageId = 0;
	stageNumber = "";
	supervisorPin = "";
	supervisorRequestReasons: SupervisorRequestReason[] = [];
	workOrderId = 0;

	constructor(private route: ActivatedRoute, private authService: AuthService, private toastService: ToastService, private interfaceDeviceService: InterfaceDeviceService, private workOrderStageService: WorkOrderStageService, private machineService: MachineService, private appSettingsService: AppSettingsService, private firewallLogService: FirewallLogService, private supervisorRequestReasonService: SupervisorRequestReasonService, private firewallLogFailureReasonService: FirewallLogFailureReasonService) {
		this.machineRequestTypes = GetPropertiesFromEnum(MachineRequestType);
		this.getFailureReasons();
		this.areasOfIssue = [
			"CAD Issue",
			"Health and Safety",
			"Issue Found at Customer",
			"Maintenance Issue",
			"Person / Training Issue",
			"Process wrong",
			"Process - Assembly",
			"Process - 5 Axis Issue",
			"Process - Flat Laser issue",
			"Process - Goods-In",
			"Process - Press Issue",
			"Process - Press Brake issue",
			"Process - Weld Issue",
			"Process - Spot Weld Issue",
			"Process - Kingsland Issue",
			"Process - Fab/Deburr Issue",
			"Process - Firewall Issue",
			"Process - Logistics issue",
			"Process - Quality Issue",
			"Process - Toolroom",
			"Supplier - Material Issue",
			"Supplier - Outsource Issue",
		];
		this.getFailureReasons();
		this.getSupervisorRequestReasons();
		this.currentStatusColor = GetProductionStatusColor(ProductionStatus.Idle);
		this.route.params
			.subscribe((params) => {
				this.interfaceDeviceId = Number.parseInt(params.id);
				this.isLoading = true;
				this.showPopup = true;
				this.getInterfaceDevice();
				setTimeout(() => {
					this.isLoading = false;
					this.showPopup = false;
				}, 2000);
			});
	}

	cancelCloseSupervisorRequest() {
		this.showPopup = false;
		this.showCloseSupervisorRequestForm = false;
		this.showCloseSupervisorRequestFormLogin = false;
		this.closeSupervisorRequestDto = new CloseSupervisorRequest();
	}

	cancelMachineRequest() {
		this.showPopup = false;
		this.showOpenMachineRequestForm = false;
	}

	cancelSupervisorRequest() {
		this.showPopup = false;
		this.showOpenSupervisorRequestForm = false;
	}

	changeMode(status: ProductionStatus) {
		this.submitProductionMode(status);
		this.toggleMode();
	}

	closeSupervisor() {
		this.showSupervisor = false;
		this.showPopup = false;
	}

	closeSupervisorRequest() {
		if (this.openSupervisorRequestId === null || this.openSupervisorRequestId === undefined) {
			return;
		}

		this.closeSupervisorRequestDto = new CloseSupervisorRequest();
		this.closeSupervisorRequestDto.supervisorRequestId = this.openSupervisorRequestId;

		this.supervisorPin = "";

		// open the modal with the supervisor pin
		this.showPopup = true;
		this.showCloseSupervisorRequestFormLogin = true;
	}

	getData() {
		if (this.interfaceDevice.machineId === undefined || this.interfaceDevice.machineId === null) {
			return;
		}
		this.machineService.app_OpsPlannerForMachine(this.interfaceDevice.machineId)
			.subscribe(
				(res: any) => {
					if (res.response.length > 1) {
						this.machine = res.response[0];
						this.machineId = res.response[0].machineId;
						this.currentStatus = res.response[0].productionStatus;
						this.currentStatusColor = this.renderStatusColor();
						this.availableStages = res.response[0].availableStages;
						this.runningStages = res.response[0].runningStages;
						let profileId = 0;
						this.openSupervisorRequestId = res.response[0].openSupervisorRequestId;
						console.log(this.runningStages.length);
						if (this.runningStages.length > 0) {
							this.stageId = this.runningStages[0].id;
							this.availableStages = this.runningStages;
							this.partImage = res.response[0].runningStages[0].partImage;
							this.part = res.response[0].runningStages[0];
							this.clientName = res.response[0].runningStages[0].clientName;
							this.operatorName = res.response[0].runningStages[0].assignedUserProfileFullName;
							this.stageNumber = res.response[0].runningStages[0].operationNumber;
							this.machineId = res.response[0].runningStages[0].machineId;
							profileId = res.response[0].runningStages[0].assignedUserProfileId;
							this.workOrderId = res.response[0].runningStages[0].workOrderId;
							this.quantityComplete = res.response[0].runningStages[0].quantityCompleted;
							this.quantityRequired = res.response[0].runningStages[0].quantityRequired;
						} else {
							this.partImage = res.response[0].availableStages[0].partImage;
							this.clientName = res.response[0].availableStages[0].clientName;
							this.part = res.response[0].availableStages[0];
							this.stageNumber = res.response[0].availableStages[0].operationNumber;
							this.stageId = res.response[0].availableStages[0].id;
							this.machineId = res.response[0].availableStages[0].machineId;
							profileId = res.response[0].availableStages[0].assignedUserProfileId;
							this.operatorName = res.response[0].availableStages[0].assignedUserProfileFullName;
							this.workOrderId = res.response[0].availableStages[0].workOrderId;
							this.quantityComplete = res.response[0].availableStages[0].quantityCompleted;
							this.quantityRequired = res.response[0].availableStages[0].quantityRequired;
						}
						this.appSettingsService.set("profileId", profileId);
						this.profileId = profileId;
					}
				},
				(err: any) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getEnvironmentProperty(property: string) {
		// @ts-ignore // Required to get around having to iterate through the object
		return environment["build"][property];
	}

	getFailureReasons() {
		this.firewallLogFailureReasonService.app_allActive()
			.subscribe(
				(res: any) => {
					this.nokReasons = res.response;
					this.nokReasons.sort((a,b) => a.reason.localeCompare(b.reason));
				},
				(err) => console.log(err)
			);
	}

	getInterfaceDevice() {
		this.interfaceDeviceService.app_InterfaceById(this.interfaceDeviceId)
			.subscribe(
				(res: any) => {
					this.interfaceDevice = res.response;
					this.getData();
				},
				(err: any) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getSupervisorRequestReasons() {
		this.supervisorRequestReasonService.app_allActive()
			.subscribe(
				(res: any) => {
					this.supervisorRequestReasons = res.response;
				},
				(err: any) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	increaseScrap() {
		this.workOrderStageService.increaseScrapAmount(this.availableStages[0].id,1)
			.subscribe(
				() => {
					this.reloadPage();
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	openMachineRequestModal() {
		this.showPopup = true;
		this.showOpenMachineRequestForm = true;
	}

	openSupervisorRequest() {
		this.showPopup = true;
		this.showOpenSupervisorRequestForm = true;
	}

	pauseWorkOrder() {
		this.workOrderStageService.app_togglePause(this.availableStages[0].id)
			.subscribe(
				() => {
					this.toastService.success("Stage Paused due to incomplete quantity");
					this.reloadPage();
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	reloadPage() {
		this.isLoading = true;
		this.showPopup = true;
		this.getData();
		setTimeout(() => {
			this.isLoading = false;
			this.showPopup = false;
		}, 2000);
	}

	renderStatusColor() {
		return GetProductionStatusColor(this.currentStatus);
	}

	submitArea() {
		console.log(this.selectedArea);
	}

	submitCloseSupervisorRequest() {
		this.machineService.app_CloseSupervisorRequest(this.closeSupervisorRequestDto)
			.subscribe(
				() => {
					this.showCloseSupervisorRequestForm = false;
					this.reloadPage();
				},
				(err) => {
					this.toastService.error("Something went wrong!");
					console.log(err);
				}
			);
	}

	submitCloseSupervisorRequestLogin() {
		this.authService.app_getSupervisorIdByCode(this.supervisorPin)
			.subscribe(
				(res: any) => {
					this.closeSupervisorRequestDto.supervisorId = res.response;
					this.showCloseSupervisorRequestForm = true;
					this.showCloseSupervisorRequestFormLogin = false;
				},
				(err) => {
					this.toastService.error("Invalid PIN");
					console.log(err);
				}
			);
	}

	submitCompleted() {
		let firewall = false;
		this.toggleComplete();
		this.isLoading = true;
		this.showPopup = true;
		if (this.availableStages[0].processId == 6 || this.availableStages[0].processId == 53) {
			this.quantityEntered = this.quantityEntered + this.quantityNok;
			firewall = true;
		}
		this.workOrderStageService.completedQuantityApiKey(this.availableStages[0].id, this.quantityEntered - this.quantityComplete)
			.subscribe(
				() => {
					this.toastService.success("Part Complete Submitted Successfully!");
					if (firewall) {
						this.showFirewall = false;
						this.showNok = false;
						if ((this.quantityComplete + this.quantityNok) != this.quantityRequired) {
							//Pause Work Order.
							this.pauseWorkOrder();
						}
						if(this.quantityNok > 0){
							this.increaseScrap();
						}
					}
					this.reloadPage();
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	submitFirewall() {
		if (this.quantityNok > 0) {
			this.showFirewall = false;
			this.showNok = true;
		} else {
			const log = new FirewallLog();
			log.numberOfPartsChecked = this.quantityEntered;
			log.numberOfPartsFailed = this.quantityNok;
			log.operatorId = this.profileId;
			log.partId = this.part.id;
			this.submitFirewallLogService(log);
			this.showFirewall = false;
			this.showPopup = false;

		}
	}

	submitFirewallLog() {
		// Create log.
		const log = new FirewallLog();
		log.areaOfIssue = this.selectedArea;
		log.failureReasonId = this.selectedReason;
		log.numberOfPartsChecked = this.quantityEntered;
		log.numberOfPartsFailed = this.quantityNok;
		log.numberOfPartsReworkable = 0;
		log.isProduction = this.selectedProduction == true ? true : false;
		log.prePaint = this.selectedPaint == true  ? true : false;
		log.asnNumber = "";
		log.operatorId = this.profileId;
		log.partId = this.part.id;

		this.submitFirewallLogService(log);

	}

	submitFirewallLogService(log: FirewallLog) {
		this.firewallLogService.appCreateFirewallLog(log)
			.subscribe(
				() => {

					this.showPopup = false;
					this.showNok = false;
					this.showFirewall = false;
					this.submitCompleted();
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	submitIsProduction() {
		console.log(this.selectedProduction);
	}

	submitMachineRequest() {
		this.machineService.app_OpenMachineRequestForStage(this.stageId, this.selectedMachineRequestType)
			.subscribe(
				() => {
					this.toastService.success("Request Submitted Successfully!");
					this.showOpenMachineRequestForm = false;
					this.showSupervisor = true;
					this.selectedMachineRequestType = MachineRequestType.Stillage;
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
		this.getData();
	}

	submitPaint() {
		console.log(this.selectedPaint);
	}

	submitProductionMode(prodStatus: ProductionStatus) {
		this.machineService.app_updateProductionStatus(this.machineId, prodStatus)
			.subscribe(
				() => {
					this.toastService.success("Production Mode Changed Successfully!");
					this.reloadPage();
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
	}

	submitReason() {
		console.log(this.selectedReason);
	}

	submitSupervisorRequest() {
		this.machineService.app_requestSupervisorForStage(this.stageId, this.selectedSupervisorRequestReasonId)
			.subscribe(
				() => {
					this.toastService.success("Request Submitted Successfully!");
					this.showOpenSupervisorRequestForm = false;
					this.showSupervisor = true;
					this.getData();
				},
				(err) => {
					this.toastService.error("Something Went Wrong!");
					console.log(err);
				}
			);
		this.getData();
	}

	/* Toggles */
	toggleComplete() {
		if (this.availableStages[0].processId == 6 || this.availableStages[0].processId == 53) {
			this.showFirewall = !this.showFirewall;
			this.showPopup = !this.showPopup;
		} else {
			this.showComplete = !this.showComplete;
			this.showPopup = !this.showPopup;
		}
	}

	toggleMode() {
		this.showMode = !this.showMode;
		this.showPopup = !this.showPopup;
	}

	toggleSupervisor() {
		this.showSupervisor = !this.showSupervisor;
		this.showPopup = !this.showPopup;
	}

	updateNokQuantity() {
		this.quantityNok = this.quantityRequired - this.quantityEntered;
	}

	windowWidthCheck() {
		return window.innerWidth >= 768;
	}
}